import React, { useContext, useEffect } from "react"
import { useDividas } from "../../../context/DividasContext"
import { DiscadorContext } from "../../Discador"
import { DiscadorContext as DiscContextExpert } from "../../DiscadorExpert"

interface SelectOperadoraProps {
  operadora: string
  setOperadora: React.Dispatch<React.SetStateAction<string>>
}

export const SelectOperadora = ({ operadora, setOperadora }: SelectOperadoraProps) => {
  const { devedorCadastro } = useDividas()

  const { isLogged, desconectarWS, isConnected } = useContext(DiscadorContext)
  const { isLogged: isLoggedExpert, desconectarWS: desconectarWSExpert, isConnected: isConnectedExpert } = useContext(DiscContextExpert)

  function blockSelect() {
    if (operadora === '3C' && isLogged) return true
    if (operadora === 'Expert' && isLoggedExpert) return true
    if (devedorCadastro?.cpfcnpj) return true
    return false
  }

  useEffect(() => {
    if (isConnectedExpert && operadora === '3C') {
      desconectarWSExpert()
    }
    if (isConnected && operadora === 'Expert') {
      desconectarWS()
    }
  }, [desconectarWS, desconectarWSExpert, isConnected, isConnectedExpert, operadora])

  return (
    <div className="flex items-center gap-4">
      <label htmlFor="operadora" className="text-primary font-bold">Discador: </label>
      <select
        className="w-full rounded-sm bg-gray-200 p-2 text-xs font-bold text-gray-600 outline-none "
        value={operadora}
        onChange={(e) => setOperadora(e.target.value)}
        disabled={blockSelect()}
      >
        <option value={'3C'}>3C</option>
        <option value={'Expert'}>Expert</option>
      </select>
    </div>
  )
}